import type {
  ChartV2Point,
  ChartV2ResolvedSeries,
} from '../types/chart-v2.types';
import { isOhlcPoint, pointValue } from './helpers';

const firstVisibleValue = (
  data: ChartV2Point[],
  xDomain: [number, number]
): number | undefined => {
  for (const p of data) {
    if (p.time >= xDomain[0] && p.time <= xDomain[1]) {
      return isOhlcPoint(p) ? p.close : pointValue(p);
    }
  }

  return undefined;
};

/**
 * Rebase a series to percentage change from its first visible value inside
 * `xDomain`. OHLC shapes collapse to line (close) — candle/bar visuals do
 * not make sense for a relative-to-start comparison.
 */
export const rebaseToPercentage = (
  series: ChartV2ResolvedSeries,
  xDomain: [number, number]
): ChartV2ResolvedSeries => {
  const base = firstVisibleValue(series.data, xDomain);

  if (!base || base === 0) {
    return series;
  }

  const data: ChartV2Point[] = series.data.map(p => {
    const v = isOhlcPoint(p) ? p.close : pointValue(p);

    return { time: p.time, value: ((v - base) / base) * 100 };
  });

  return {
    ...series,
    seriesType: 'line',
    data,
  };
};
